import axios from '@/request';
import qs from 'qs';

export default {
  async getLogs(params: any) {
    return axios.get('equipoplogs/list', { params });
  },
  async gateAccessRecord(params: any) {
    return axios.get('equipoplogs/gate-access-record', { params })
  }
};
